import TomSelect from "tom-select"

export function initRemoteAssociationSelects(root = document) {
  root.querySelectorAll(".tom-select-remote").forEach(element => {
    if (element.tomselect) return

    new TomSelect(element, {
      create: false,
      valueField: "value",
      labelField: "text",
      searchField: "text",
      maxOptions: 20,
      loadThrottle: 300,
      plugins: ["remove_button", "dropdown_input"],
      load(query, callback) {
        const url = element.dataset.url
        if (!url || query.length < 2) return callback()

        fetch(`${url}?q=${encodeURIComponent(query)}`, {
          headers: { Accept: "application/json" }, credentials: "same-origin"
        })
          .then(response => response.json())
          .then(json => callback(json))
          .catch(() => callback())
      },
      render: {
        option: (data, escape) => `<div>${escape(data.text)}</div>`,
        item: (data, escape) => `<div>${escape(data.text)}</div>`
      }
    })
  })
}
